import type { SchemaBuiltInItem } from './create-schema';
import {
	confluenceJiraIssue,
	confluenceUnsupportedBlock,
	confluenceUnsupportedInline,
	doc,
	paragraph,
	text,
	bulletList,
	orderedListWithOrder,
	listItem,
	heading,
	codeBlock,
	extendedPanel,
	extendedPanelC1,
	rule,
	image,
	mention,
	media,
	mediaInline,
	mediaSingleFull,
	mediaGroup,
	hardBreak,
	emoji,
	table,
	tableCell,
	tableHeader,
	tableRow,
	decisionList,
	decisionItem,
	taskList,
	taskItem,
	blockTaskItem,
	unknownBlock,
	extension,
	inlineExtension,
	bodiedExtension,
	multiBodiedExtension,
	extensionFrame,
	date,
	placeholder,
	layoutSection,
	layoutColumn,
	inlineCard,
	blockCard,
	unsupportedBlock,
	unsupportedInline,
	status,
	expandWithNestedExpand,
	nestedExpand,
	embedCard,
	caption,
	extendedBlockquote,
	syncBlock,
	bodiedSyncBlock,
} from './nodes';

export const nodesInOrder: SchemaBuiltInItem[] = [
	{ name: 'doc', spec: doc },
	{ name: 'paragraph', spec: paragraph },
	{ name: 'text', spec: text },
	{ name: 'bulletList', spec: bulletList },
	{ name: 'orderedList', spec: orderedListWithOrder },
	{ name: 'listItem', spec: listItem },
	{ name: 'heading', spec: heading },
	{ name: 'blockquote', spec: extendedBlockquote },
	{ name: 'codeBlock', spec: codeBlock },
	{ name: 'panel', spec: extendedPanel(true) },
	{ name: 'panel_c1', spec: extendedPanelC1(true) },
	{ name: 'rule', spec: rule },
	{ name: 'image', spec: image },
	{ name: 'mention', spec: mention },
	{ name: 'caption', spec: caption },
	{ name: 'media', spec: media },
	{ name: 'mediaGroup', spec: mediaGroup },
	{ name: 'mediaSingle', spec: mediaSingleFull },
	{ name: 'mediaInline', spec: mediaInline },
	{ name: 'placeholder', spec: placeholder },
	{ name: 'layoutSection', spec: layoutSection },
	{ name: 'layoutColumn', spec: layoutColumn },
	{ name: 'hardBreak', spec: hardBreak },
	{ name: 'emoji', spec: emoji },
	{ name: 'table', spec: table },
	{ name: 'tableCell', spec: tableCell },
	{ name: 'tableRow', spec: tableRow },
	{ name: 'tableHeader', spec: tableHeader },
	{ name: 'confluenceJiraIssue', spec: confluenceJiraIssue },
	{ name: 'confluenceUnsupportedInline', spec: confluenceUnsupportedInline },
	{ name: 'confluenceUnsupportedBlock', spec: confluenceUnsupportedBlock },
	{ name: 'decisionList', spec: decisionList },
	{ name: 'decisionItem', spec: decisionItem },
	{ name: 'taskList', spec: taskList },
	{ name: 'taskItem', spec: taskItem },
	{ name: 'blockTaskItem', spec: blockTaskItem },
	{ name: 'date', spec: date },
	{ name: 'status', spec: status },
	{ name: 'expand', spec: expandWithNestedExpand },
	{ name: 'nestedExpand', spec: nestedExpand },
	{ name: 'extension', spec: extension },
	{ name: 'inlineExtension', spec: inlineExtension },
	{ name: 'bodiedExtension', spec: bodiedExtension },
	{ name: 'multiBodiedExtension', spec: multiBodiedExtension },
	{ name: 'extensionFrame', spec: extensionFrame },
	{ name: 'inlineCard', spec: inlineCard },
	{ name: 'blockCard', spec: blockCard },
	{ name: 'embedCard', spec: embedCard },
	{ name: 'syncBlock', spec: syncBlock },
	{ name: 'bodiedSyncBlock', spec: bodiedSyncBlock },
	{ name: 'unknownBlock', spec: unknownBlock },
	{ name: 'unsupportedBlock', spec: unsupportedBlock },
	{ name: 'unsupportedInline', spec: unsupportedInline },
];
